import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f5fcb0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "title-container"
}
const _hoisted_2 = { class: "title-icon-container" }
const _hoisted_3 = { class: "button-container" }
const _hoisted_4 = { class: "card-content-container" }

import DxButton from "devextreme-vue/button";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'info-card',
  props: {
  /**
   * The title or heading associated with the component.
   * @type {string}
   * @default: ''
   */
  title: {
    type: String,
    default: "",
  },
  /**
   * Determines whether to show the edit button.
   * @type {boolean}
   * @default false
   */
  showEditButton: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether to disable the edit button.
   * @type {boolean}
   * @default false
   */
  disableEditButton: {
    type: Boolean,
    default: false,
  },

  /**
   * The width of the component, defined as a string.
   * @type {string}
   * @default '100%'
   */
  width: {
    type: String,
    default: "100%",
  },
  /**
   * Determines whether to apply edge to edge on content.
   * @type {boolean}
   * @default false
   */
  edgeToEdgeContent: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether to display icon after title.
   * @type {boolean}
   * @default false
   */
  iconAfterTitle: {
    type: Boolean,
    default: false,
  },
  height: {
    type: String,
    default: "",
  },
},
  emits: ["editClicked"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "f27ec844": (__props.width),
  "073b9e48": (iconTitleContainerFlexDirection.value),
  "e53b04c2": (contentMargin.value)
}))





const screenSize = ref(screen.width);
const contentMargin = computed(() =>
  props.edgeToEdgeContent ? "0rem" : "0.4rem 0.75rem",
);

const iconTitleContainerFlexDirection = computed(() =>
  props.iconAfterTitle ? "row-reverse" : "row",
);

const heightStyle = computed(() => {
  if (screenSize.value > 768)
    return props.height ? { "min-height": props.height } : {};
  return "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(heightStyle.value),
    class: "dx-card card-container"
  }, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "icon"),
            _createElementVNode("h6", null, _toDisplayString(__props.title), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "extra-icon", { class: "extra-icon" }),
            (__props.showEditButton)
              ? (_openBlock(), _createBlock(_unref(DxButton), {
                  key: 0,
                  class: "new-button",
                  disabled: __props.disableEditButton,
                  icon: "fas fa-pencil-alt",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('editClicked')))
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 4))
}
}

})